import type { CustomPlugin, CustomValues } from '@atlassian/browser-metrics/types';

import { isInitial } from '../utils/browserMetricsState.ts';

import { getCacheAttributes } from './getCacheAttributes.ts';
import { getjQueryVersion } from './getjQueryVersion.ts';

export const customEventPlugin: CustomPlugin = ({ stop }): CustomValues => {
	const customAttributes: CustomValues = {
		initial: isInitial(),
		criticalAssets: getCacheAttributes(stop),
		jqVer: getjQueryVersion(),
	};
	return customAttributes;
};
